import React, { useState } from 'react'

import Cookies from 'js-cookie'
import { useTranslation } from 'react-i18next'

import { Button } from '../buttons/Button'

export const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation()
    const [isOpen, setIsOpen] = useState(false)

    const toggleDropdown = () => setIsOpen(!isOpen)

    const changeLanguage = (lang: string) => {
        i18n.changeLanguage(lang).then()
        setIsOpen(false)
        Cookies.set('preferredLanguage', lang, { expires: 365 })
    }

    return (
        <div className="relative">
            <Button onClick={toggleDropdown} className="flex items-center">
                {i18n.language.toUpperCase()}
                <svg
                    className="w-4 h-4 ml-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </Button>
            {isOpen && (
                <div className="absolute right-0 mt-2 py-2 w-48 bg-secondary-green rounded-md shadow-xl z-20">
                    <Button
                        onClick={() => changeLanguage('en')}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left">
                        English
                    </Button>
                    <Button
                        onClick={() => changeLanguage('de')}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left">
                        Deutsch
                    </Button>
                    <Button
                        onClick={() => changeLanguage('fr')}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left">
                        Français
                    </Button>
                    <Button
                        onClick={() => changeLanguage('es')}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left">
                        Español
                    </Button>
                    <Button
                        onClick={() => changeLanguage('tr')}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left">
                        Türkçe
                    </Button>
                    <Button
                        onClick={() => changeLanguage('ar')}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left">
                        عربي
                    </Button>
                </div>
            )}
        </div>
    )
}
